import React from 'react'

const Google = (
  <div className='md:w-4/5 mx-auto py-10 text-lg'>
    <h1 className='text-2xl font-bold'>Google Analytics</h1>
    <div>
      <br />
      <p className='md:px-5 text-gray-500'>
        Data scientists also play a vital role in the digital marketing sector. Google Analytics is
        one of the top data science tools used in the industry for digital marketing.
      </p>
      <br />
      <p className='md:px-5'>
        The following are the key features and usages of Google Analytics:
      </p>
      <br />
      <div className='md:px-5'>
        <ul className='md:px-10 list-disc pl-5 text-gray-500'>
          <li>
            Helps web admins access, analyze, and visualize data to gain a better
            understanding of user interaction with websites.
          </li>
          <br />
          <li>
            Helps in making better marketing decisions by recognizing and using the data
            trail left behind by users on a website.
          </li>
          <br />
          <li>
            With the help of its easy-to-use interface and high-end analytics, Google
            Analytics can also be used by nontechnical professionals to perform data
            analytics.
          </li>
        </ul>
      </div>
    </div>
  </div>
)

export default Google